import { registerPlugin } from '@capacitor/core';
const CIDPrint = registerPlugin('CIDPrint', {
    web: () => import('./web').then(m => new m.CIDPrintWeb()),
});
export * from './definitions';
export { CIDPrint };
export * from './enums';
export * from './data';
export * from './configuration';
export * from './printer';
export * from './web';
//# sourceMappingURL=index.js.map